import { render } from "./lockers.vue?vue&type=template&id=07cdd314&scoped=true"
import script from "./lockers.vue?vue&type=script&lang=js"
export * from "./lockers.vue?vue&type=script&lang=js"

import "./lockers.vue?vue&type=style&index=0&id=07cdd314&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cdd314"]])

export default __exports__